import { PollingManager } from '../config/polling';

/**
 * Globaler Refresh-Service
 * Ermöglicht es, von überall aus alle oder spezifische Polling-Komponenten zu aktualisieren
 */
export class RefreshService {
  private static instance: RefreshService;
  private pollingManager: PollingManager;

  private constructor() {
    this.pollingManager = PollingManager.getInstance();
  }

  static getInstance(): RefreshService {
    if (!RefreshService.instance) {
      RefreshService.instance = new RefreshService();
    }
    return RefreshService.instance;
  }

  /**
   * Alle Komponenten sofort refreshen
   * Verwendung: Nach Upload, Löschung, wichtigen Aktionen
   */
  async refreshAll(): Promise<void> {
    await this.pollingManager.refreshComponents();
  }

  /**
   * Nur Sidebar-Komponenten refreshen
   * Verwendung: Nach Service Provider Änderungen
   */
  async refreshSidebars(): Promise<void> {
    await this.pollingManager.refreshComponents([
      'service-providers',
      'admin-organizations',
      'contracts'
    ]);
  }

  /**
   * Nur Dashboard-Komponenten refreshen
   * Verwendung: Nach Status-Änderungen
   */
  async refreshDashboards(): Promise<void> {
    await this.pollingManager.refreshComponents([
      'dashboard-main',
      'admin-dashboard',
      'cost-overview'
    ]);
  }

  /**
   * Nur Tabellen refreshen
   * Verwendung: Nach Datenänderungen in Listen
   */
  async refreshTables(): Promise<void> {
    await this.pollingManager.refreshComponents([
      'service-providers',
      'contracts',
      'cost-overview'
    ]);
  }

  /**
   * Spezifische Komponenten refreshen
   * @param componentIds Array von Component-IDs
   */
  async refreshComponents(componentIds: string[]): Promise<void> {
    await this.pollingManager.refreshComponents(componentIds);
  }

  /**
   * Status des Polling-Systems abrufen
   */
  getPollingStatus() {
    return this.pollingManager.getStatus();
  }
}

// Singleton-Instanz exportieren für einfache Nutzung
export const refreshService = RefreshService.getInstance();

// Convenience-Funktionen für häufige Use Cases
export const refreshAll = () => refreshService.refreshAll();
export const refreshSidebars = () => refreshService.refreshSidebars();
export const refreshDashboards = () => refreshService.refreshDashboards();
export const refreshTables = () => refreshService.refreshTables(); 